import React from "react"
import { Alert, Button, Col, FormFeedback, FormGroup, FormText, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import { ENVELOPE_WEIGHT_LIMIT, PACKAGE_NAME_LIMIT, PACKAGE_TYPES } from "./settingsForm"

// A shipping package, added or edited: its name, type, sides in whole centimetres and own weight; an
// edited one can be deactivated, unless it is the default, which stays an active box. `editing` holds
// the form's values and the errors of its last check; `unchanged` means there is nothing to save.
export default function PackageDialog({ editing, isDefault, unchanged, pending, failure, onChange, onSave, onClose }) {
  const { packageId, name, form, errors = {} } = editing
  const close = pending ? undefined : onClose
  const field = (key, label, props = {}, children) => <FormGroup>
    <Label for={`logistics-package-${key}`}>{label}</Label>
    <Input id={`logistics-package-${key}`} value={form[key]} invalid={Boolean(errors[key])} onChange={event => onChange({ ...form, [key]: event.target.value })}
      {...props}>{children}</Input>
    {errors[key] && <FormFeedback>{errors[key]}</FormFeedback>}
  </FormGroup>
  const centimetres = { type: "number", min: 1, step: 1 }

  return <Modal isOpen centered toggle={close} labelledBy="logistics-package-title">
    <ModalHeader id="logistics-package-title" toggle={close}>{packageId ? `Edit shipping package · ${name}` : "Add shipping package"}</ModalHeader>
    <ModalBody>
      <Row form>
        <Col sm={7}>{field("name", "Name", { maxLength: PACKAGE_NAME_LIMIT, placeholder: "e.g. Box XL" })}</Col>
        <Col sm={5}>{field("type", "Type", { type: "select" }, PACKAGE_TYPES.map(([value, label]) =>
          <option key={value} value={value} disabled={isDefault && value !== "box"}>{label}</option>))}</Col>
      </Row>
      <Row form>
        <Col xs={4}>{field("length", "Length (cm)", centimetres)}</Col>
        <Col xs={4}>{field("width", "Width (cm)", centimetres)}</Col>
        {form.type !== "envelope" && <Col xs={4}>{field("height", "Height (cm)", centimetres)}</Col>}
      </Row>
      <Row form>
        <Col xs={4}>{field("weight", "Own weight (kg)", { type: "number", min: 0, step: "0.01" })}</Col>
      </Row>
      {form.type === "envelope" && <FormText className="mt-n2 mb-2 d-block">Cargus takes envelopes only for documents, such as diplomas: up to
        {` ${ENVELOPE_WEIGHT_LIMIT} kg`}, at most 9 per AWB. An envelope cannot be the default package.</FormText>}
      {packageId && <FormGroup check>
        <Input id="logistics-package-active" type="checkbox" checked={form.active} disabled={isDefault}
          onChange={event => onChange({ ...form, active: event.target.checked })} />
        <Label check for="logistics-package-active">Active</Label>
        <FormText className="d-block">{isDefault ? "The default package stays an active box. Make another box the default to change that."
          : "An inactive package is no longer offered for new parcels."}</FormText>
      </FormGroup>}
      {failure && <Alert color="danger" className="mt-3 mb-0">{failure}</Alert>}
    </ModalBody>
    <ModalFooter>
      <Button color="light" disabled={pending} onClick={onClose}>Cancel</Button>
      <Button color="primary" disabled={pending || unchanged} onClick={onSave}>{pending ? "Saving…" : packageId ? "Save" : "Add"}</Button>
    </ModalFooter>
  </Modal>
}
